export const COMMON_TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern Time (New York, Miami)' },
  { value: 'America/Chicago', label: 'Central Time (Chicago)' },
  { value: 'America/Denver', label: 'Mountain Time (Denver)' },
  { value: 'America/Phoenix', label: 'Arizona (Phoenix, no DST)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (Los Angeles)' },
  { value: 'America/Anchorage', label: 'Alaska (Anchorage)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii (Honolulu)' },
  { value: 'America/Puerto_Rico', label: 'Atlantic (Puerto Rico)' },
];

export const allTimeZones = () =>
  typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : COMMON_TIMEZONES.map((z) => z.value);

const DEFAULT_TZ = 'America/New_York';

const parts = (date, tz, opts) =>
  Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: tz || DEFAULT_TZ, ...opts }).formatToParts(date).map((p) => [p.type, p.value]));

export const todayInTz = (tz) => {
  const p = parts(new Date(), tz, { year: 'numeric', month: '2-digit', day: '2-digit' });
  return `${p.year}-${p.month}-${p.day}`;
};

export const formatDateTimeInTz = (iso, tz) =>
  iso
    ? new Intl.DateTimeFormat('en-US', {
        timeZone: tz || DEFAULT_TZ, month: 'short', day: 'numeric', year: 'numeric',
        hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
      }).format(new Date(iso))
    : '';

export const previewBookingWindow = (tz, switchTime) => {
  const p = parts(new Date(), tz, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  const nowLabel = new Intl.DateTimeFormat('en-US', { timeZone: tz || DEFAULT_TZ, hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(new Date());
  const opensTomorrow = `${p.hour}:${p.minute}` >= (switchTime || '14:00');
  return { nowLabel, opensOn: opensTomorrow ? 'tomorrow' : 'today' };
};

export const formatSwitchTime = (hhmm) => {
  const [h, m] = (hhmm || '14:00').split(':').map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
};
